(() => {
  'use strict';
  const mount = (scope = document) => {
    scope.querySelectorAll('[data-predictive-search]').forEach(form => {
      if (form.dataset.enhanced) return;
      form.dataset.enhanced = 'true';
      const input = form.querySelector('input[name=q]');
      const panel = form.querySelector('[data-predictive-results]');
      const status = form.querySelector('[data-predictive-status]');
      if (!input || !panel) return;
      let controller, timer, generation = 0, active = -1;
      const options = () => Array.from(panel.querySelectorAll('[data-predictive-option]'));
      const close = () => {
        ++generation;
        clearTimeout(timer);
        controller?.abort();
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        form.removeAttribute('aria-busy');
        active = -1;
        if (status) status.textContent = '';
      };
      const select = index => {
        const items = options();
        if (!items.length) return;
        active = (index + items.length) % items.length;
        items.forEach((item, i) => item.setAttribute('aria-selected', String(i === active)));
        input.setAttribute('aria-activedescendant', items[active].id);
      };
      const suggest = async () => {
        const terms = input.value.trim();
        if (terms.length < 2) { close(); return; }
        const version = ++generation;
        controller?.abort();
        controller = new AbortController();
        form.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(form.dataset.predictiveUrl, location.origin);
          url.searchParams.set('q', terms);
          url.searchParams.set('section_id', 'lh-predictive-search');
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '5');
          const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Suggestions unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (version !== generation || document.activeElement !== input) return;
          const content = html.querySelector('[data-predictive-content]');
          panel.replaceChildren();
          if (!content) { close(); return; }
          panel.append(document.importNode(content, true));
          panel.hidden = false;
          active = -1;
          input.setAttribute('aria-expanded', 'true');
          input.removeAttribute('aria-activedescendant');
          if (status) status.textContent = form.dataset.readyLabel;
        } catch (error) {
          if (error.name !== 'AbortError' && version === generation) close();
        } finally {
          if (version === generation) form.removeAttribute('aria-busy');
        }
      };
      input.addEventListener('input', event => {
        if (event.isComposing) return;
        clearTimeout(timer);
        ++generation;
        controller?.abort();
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        active = -1;
        if (input.value.trim().length < 2) { close(); return; }
        timer = setTimeout(suggest, 250);
      });
      input.addEventListener('keydown', event => {
        if (event.key === 'Escape') { close(); return; }
        if (panel.hidden) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          select(active < 0 ? (event.key === 'ArrowDown' ? 0 : options().length - 1) : active + (event.key === 'ArrowDown' ? 1 : -1));
        } else if (event.key === 'Enter' && active >= 0) {
          const link = options()[active]?.querySelector('a');
          if (link) { event.preventDefault(); location.assign(link.href); }
        }
      });
      panel.addEventListener('click', event => {
        if (event.target.closest('[data-predictive-close]')) { close(); input.focus(); }
      });
      form.addEventListener('focusout', event => { if (!form.contains(event.relatedTarget)) close(); });
      document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) close(); });
      form.addEventListener('submit', close);
    });
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.refined) return;
      section.dataset.refined = 'true';
      const zoom = section.querySelector('[data-image-zoom]');
      const dialog = section.parentElement.querySelector('[data-image-dialog]');
      const image = section.querySelector('.product-primary-image');
      if (zoom && dialog && image && typeof dialog.showModal === 'function') {
        zoom.disabled = false;
        zoom.addEventListener('click', () => {
          const enlarged = dialog.querySelector('[data-zoom-image]');
          enlarged.src = image.src;
          enlarged.alt = image.alt;
          dialog.showModal();
          document.documentElement.classList.add('lh-zoom-open');
        });
        dialog.querySelector('[data-image-dialog-close]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          const box = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
        });
        dialog.addEventListener('close', () => document.documentElement.classList.remove('lh-zoom-open'));
      }
      const copy = section.querySelector('[data-copy-design]');
      copy?.addEventListener('click', async () => {
        const status = section.querySelector('[data-product-action-status]');
        try {
          const canonical = document.querySelector('link[rel=canonical]')?.href || location.href;
          await navigator.clipboard.writeText(canonical);
          if (status) status.textContent = copy.dataset.copiedLabel;
          copy.textContent = copy.dataset.copiedLabel;
        } catch { if (status) status.textContent = copy.dataset.copyError; }
      });
    });
  };
  const enquiry = document.querySelector('[data-design-enquiry]');
  if (enquiry && !enquiry.value.trim()) {
    const design = new URL(location.href).searchParams.get('design');
    if (design) enquiry.value = enquiry.dataset.enquiryTemplate.replace('[design]', design.slice(0,160));
  }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
